import React from 'react';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {
    Button,
    Eyebrow,
    EyebrowProps,
    OutlinedCard,
    Typography,
    VerticalSpacer
} from '../../../elements';

const ContactCardWrapper = styled.div`
    && {
        .ue-outlined-card {
            width: 100%;
            max-width: ${(p) => p.theme.spacing(52)}px;
            align-content: center;
            padding: ${(p) => p.theme.spacing(6)}px;
            ${(p) => p.theme.breakpoints.down('sm')} {
                padding: ${(p) => p.theme.spacing(3)}px;
            }
        }
        .paragraph.caption {
            color: ${(p) =>
                p.theme.ifLight(p, 'theme.palette.neutral.steel', 'theme.palette.neutral.stone')};
        }
    }
`;

export interface ContactCardProps {
    accentColor?: AccentColorOptions;
    eyebrow?: EyebrowProps;
    title?: string;
    email?: string;
    buttonText?: string;
    richText?: string;
}

export const ContactCard = ({
    accentColor = 'sky',
    eyebrow = {text: 'Contact'},
    title,
    email,
    buttonText = 'Send us a message',
    richText
}: ContactCardProps): JSX.Element => {
    return (
        <ContactCardWrapper>
            <OutlinedCard accentColor={accentColor} topSpacing={false} centered>
                {eyebrow && eyebrow.text && (
                    <>
                        <Eyebrow as="h1" {...eyebrow} />
                        <VerticalSpacer variant="eyebrow" />
                    </>
                )}
                {title && (
                    <>
                        <Typography variant="h3" big>
                            {title}
                        </Typography>
                        <VerticalSpacer variant="custom" spacing={4} />
                    </>
                )}
                {email && (
                    <Button type={'secondary'} color={accentColor} href={`mailto:${email}`}>
                        {buttonText}
                    </Button>
                )}
                {richText && (
                    <>
                        <VerticalSpacer variant="custom" spacing={2} />
                        <Typography variant="p" caption accentColor={accentColor}>
                            {richText}
                        </Typography>
                    </>
                )}
            </OutlinedCard>
        </ContactCardWrapper>
    );
};
